import { useContext } from 'react';
import UiContext from 'context/UiContext';

const useLoader = () => {
  const context = useContext(UiContext);

  return {
    showLoader: context ? context.state.showLoader : 0,
    startLoader: context ? context.startLoader : () => {},
    stopLoader: context ? context.stopLoader : () => {},
  };
};

export default useLoader;
